export default function NoMatch() {
  return (
    <div className="flex justify-center items-center text-h1 h-screen text-center">Whoops,...<br />We couldn't find what <br />you're looking for.</div>
  );
}
